import {useState, useEffect, useContext} from "react";
import { GlobalContext } from '../globalState';

import '../css/viewIFrame/viewIFrame.css';

import ViewIFrame from '../conpornent/ViewIFrame';
import SummaryButton from "../conpornent/SummaryButton";

function SummryHPPage(props) {
  
  const envHP = useContext(GlobalContext).envHP;
  
  const {iframeUrl, setIframeUrl} = useContext(GlobalContext);
  
  const [seletedHp, setSelectedHp] = useState('MC');

  useEffect(()=>{
    setIframeUrl(envHP.MCURL);
  },[])


  return (
    <div>
      <div class="buttonArea">
        <SummaryButton 
          seletedHp={seletedHp}
          setSelectedHp={setSelectedHp}
          setIframeUrl={setIframeUrl}
          label='三宅医院'
          clinicStr='MC'
          url={envHP.MCURL}
        />
        <SummaryButton 
          seletedHp={seletedHp}
          setSelectedHp={setSelectedHp}
          setIframeUrl={setIframeUrl}
          label='おおふく'
          clinicStr='MOC'
          url={envHP.MOCURL}
        />
        <SummaryButton
          seletedHp={seletedHp}
          setSelectedHp={setSelectedHp}
          setIframeUrl={setIframeUrl}
          label='テラス'
          clinicStr='MCTT'
          url={envHP.MCTTURL}
        />
        <SummaryButton 
          seletedHp={seletedHp}
          setSelectedHp={setSelectedHp}
          setIframeUrl={setIframeUrl}
          label='ハロー'
          clinicStr='HELLO'
          url={envHP.HELLOURL}
        />
      </div>
      <ViewIFrame
        iframeUrl={iframeUrl}
      />
    </div>
  );
}

export default SummryHPPage;
